import ScheduleContent from './ScheduleContent';

export default ScheduleContent;
